import React from "react";
import useFetchBlob from "../../../hooks/use-fetch-blob.ts";
import SimpleLoadingIndicator from "../../simple-loading-indicator";

interface ImageLoaderProps extends React.HTMLAttributes<HTMLImageElement> {
    src: string;
    fallback?: React.ReactNode;
}

const ImageLoader: React.FC<ImageLoaderProps> = ({src, fallback, ...props}) => {
    const {isLoading, data} = useFetchBlob(src);

    if (isLoading) return (
        <div className="flex items-center justify-center w-full h-full text-sm m-auto" >
            <SimpleLoadingIndicator text="Chargement de l'image..."/>
        </div>
    );

    if (!data) {
        if (fallback !== undefined) {
            return <>{fallback}</>;
        }

        return (
            <div className="flex items-center justify-center w-full h-full text-sm text-red-900 m-auto">
                Impossible de charger l'image.
            </div>
        );
    }

    return <img src={data} alt={src} {...props} />
}

export default ImageLoader;